import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import { ref } from "vue";
import { ElMessage } from "element-plus";
import { createInvoice } from "@/entities/invoice";
import { loadHalyk, payWithHalyk } from "@/shared/lib/halyk";
var langMap = {
  kk: "kaz",
  ru: "rus",
  en: "eng"
};
var resolveLanguage = function resolveLanguage() {
  var stored = localStorage.getItem("lang") || "ru";
  return langMap[stored] || "rus";
};
var buildBackLinks = function buildBackLinks() {
  var returnUrl = window.location.href;
  return {
    back_link: returnUrl,
    failure_back_link: returnUrl
  };
};
var buildPayload = function buildPayload(_ref) {
  var transactionUuid = _ref.transactionUuid,
    amount = _ref.amount,
    description = _ref.description,
    language = _ref.language,
    backLink = _ref.backLink,
    failureBackLink = _ref.failureBackLink;
  var links = buildBackLinks();
  return {
    transaction_uuid: transactionUuid,
    amount: Number(amount),
    description: (description || "").slice(0, 125),
    language: language || resolveLanguage(),
    back_link: backLink || links.back_link,
    failure_back_link: failureBackLink || links.failure_back_link
  };
};
export function useEpayPayment() {
  var loading = ref(false);
  var error = ref(null);
  var lastInvoice = ref(null);
  var payCard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(args, onClose) {
      var _invoice$payload, invoice, paymentObject, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            loading.value = true;
            error.value = null;
            _context.p = 1;
            _context.n = 2;
            return loadHalyk();
          case 2:
            _context.n = 3;
            return createInvoice(buildPayload(args));
          case 3:
            invoice = _context.v;
            lastInvoice.value = invoice;
            paymentObject = invoice === null || invoice === void 0 || (_invoice$payload = invoice.payload) === null || _invoice$payload === void 0 ? void 0 : _invoice$payload.payment_object;
            if (paymentObject) {
              _context.n = 4;
              break;
            }
            throw new Error("payment_object отсутствует в ответе /invoices");
          case 4:
            payWithHalyk(paymentObject, onClose);
            return _context.a(2, invoice);
          case 5:
            _context.p = 5;
            _t = _context.v;
            error.value = _t;
            ElMessage.error((_t === null || _t === void 0 ? void 0 : _t.message) || "Не удалось инициировать оплату");
            throw _t;
          case 6:
            _context.p = 6;
            loading.value = false;
            return _context.f(6);
          case 7:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5, 6, 7]]);
    }));
    return function payCard(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    payCard: payCard,
    loading: loading,
    error: error,
    lastInvoice: lastInvoice
  };
}